<div class="retornos-container">
  <h3>Retornos</h3>

  <div class="field-group">
    <label for="hora">Hora</label>
    <input
      id="hora"
      type="datetime-local"
      [(ngModel)]="hora"
      [min]="fechaMinima"
      class="form-control"
      placeholder="Selecciona la hora"
    />
  </div>

<div class="field-group">
  <label for="id_carril">Provenencia</label>

  <select id="id_carril" [(ngModel)]="id_carril" class="form-control">
    <option value="">Selecciona una provenencia</option>

    <option *ngFor="let item of provenienciaOptions" [value]="item.id">
      {{ item.nombre }}
    </option>
  </select>
</div>

  <div class="field-group">
    <label for="comentario">Comentario operativo</label>
    <select id="comentario" [(ngModel)]="comentarioOperativo" class="form-control">
      <option value="">Selecciona un comentario</option>
      <option *ngFor="let item of comentarioOptions" [value]="item.id">
        {{ item.comentario }}
      </option>
    </select>
  </div>

  <button type="button" class="btn btn-primary" (click)="continuar()">
    Continuar
  </button>
</div>
